// redux/verifyWholesaler/Types.ts

export const REDUCER_NAME = "verifyWholesalerSlice";

// Only for verify operation - no list needed here
export interface iWholesalerState {
  isLoading: boolean;
  errorMessage: string | null;
}

// Verify Wholesaler DTO
export interface iVerifyWholesalerDTO {
  isVerified: boolean;
}

// Response interface (if needed)
export interface iWholesalerResponse {
  id: string;
  email: string;
  name?: string;
  isVerified?: boolean;
}